import type { EndpointMap, ListResponse } from '../common';
import type {
  CreatePortfolioRequest,
  ListPortfoliosRequest,
  UpdatePortfolioAccountRequest,
  UpdatePortfolioOrdersRequest,
  UpdatePortfolioRequest,
} from './portfolio.request';
import type {
  CreatePortfolioResponse,
  PortfolioDetail,
  PortfolioListItem,
} from './portfolio.response';

/**
 * 포트폴리오 기본 CRUD. 목록은 페이지네이션 예외(DD-31 — 전체를 한 번에). 조회 범위: D3 · 관리자 = 전체, LP = 출자한 펀드가 투자한 포트폴리오, 포트폴리오 = 자기 회사.
 */
export const portfolioEndpoints = {
  listPortfolios: {
    method: 'GET',
    path: '/portfolios',
    req: {} as ListPortfoliosRequest,
    res: {} as ListResponse<PortfolioListItem>,
    errors: ['BAD_REQUEST_INVALID_PARAMETERS'],
  },
  getPortfolio: {
    method: 'GET',
    path: '/portfolios/:id',
    res: {} as PortfolioDetail,
    errors: ['NOT_FOUND_PORTFOLIO'],
  },
  createPortfolio: {
    method: 'POST',
    path: '/portfolios',
    req: {} as CreatePortfolioRequest,
    res: {} as CreatePortfolioResponse,
    errors: ['BAD_REQUEST_INVALID_PARAMETERS', 'CONFLICT_PORTFOLIO_USERNAME_DUPLICATE'],
  },
  updatePortfolio: {
    method: 'PATCH',
    path: '/portfolios/:id',
    req: {} as UpdatePortfolioRequest,
    res: {} as PortfolioDetail,
    errors: [
      'BAD_REQUEST_INVALID_PARAMETERS',
      'NOT_FOUND_PORTFOLIO',
      'FORBIDDEN_PORTFOLIO_D3_ONLY_FIELDS',
    ],
  },
  updatePortfolioAccount: {
    method: 'PUT',
    path: '/portfolios/:id/account',
    req: {} as UpdatePortfolioAccountRequest,
    res: undefined as void,
    errors: [
      'BAD_REQUEST_INVALID_PARAMETERS',
      'NOT_FOUND_PORTFOLIO',
      'CONFLICT_PORTFOLIO_USERNAME_DUPLICATE',
    ],
  },
  /** 정렬 순서 값 일괄 저장(D3 · ADMIN, DD-80). 목록 순서 = 순서 값 내림차순 → 회사 번호(DD-79) */
  updatePortfolioOrders: {
    method: 'PUT',
    path: '/portfolios/orders',
    req: {} as UpdatePortfolioOrdersRequest,
    res: undefined as void,
    errors: ['BAD_REQUEST_INVALID_PARAMETERS', 'NOT_FOUND_PORTFOLIO'],
  },
  /**
   * 삭제 = 삭제 표시(DD-47). 업무 자료가 있어도 된다 — 그 뒤로 누구에게도 보이지 않고 어떤 지표에도 들어가지 않는다.
   * 회사 회원은 로그인할 수 없다
   */
  deletePortfolio: {
    method: 'DELETE',
    path: '/portfolios/:id',
    res: undefined as void,
    errors: ['NOT_FOUND_PORTFOLIO'],
  },
} as const satisfies EndpointMap;
